import { onMounted, onUnmounted, ref } from "vue";
import type { Ref } from "vue";
import { ScreenWidth } from "constants/screenWidth";

export const useScreenWidth = (): {
    screenWidth: Ref<ScreenWidth>
    checkScreenWidth: () => ScreenWidth
} => {
    const screenWidth = ref(ScreenWidth.Desktop)
    function checkScreenWidth() {
        if(window.innerWidth > 1024) {
            return ScreenWidth.Desktop
        }
        if(window.innerWidth > 767) {
            return ScreenWidth.Tablet
        }

        return ScreenWidth.Mobile
    }

    onMounted(() => {
        screenWidth.value = checkScreenWidth()
        window.addEventListener("resize", () => {
            screenWidth.value = checkScreenWidth()
        });
    })

    onUnmounted(() => {
        window.removeEventListener("resize", checkScreenWidth);
    });

    return { screenWidth, checkScreenWidth };
}
